import axios from "axios"




export const NewContractFileds =[
    {
      text: "Title",
      Required: "Yes",
      IntName: "Title",
      Type: "Text",
      DisplayName: "Title",
      isToolTipContent: "",
      Options: "",
      ADAzureProperty: "",
      SPOProperty: "",
      id: 0,
    },
    {
      text: "Priority",
      Required: "Yes",
      IntName: "Priority",
      Type: "Choice",
      DisplayName: "Priority",
      isToolTipContent: "",
      Options: "",
      ADAzureProperty: "",
      SPOProperty: "",
      id: 1,
    },
    {
      text: "Due Date",
      Required: "Yes",
      IntName: "DueDate",
      Type: "DateTime",
      DisplayName: "Due Date",
      isToolTipContent: "",
      Options: "",
      ADAzureProperty: "",
      SPOProperty: "",
      id: 2,
    },
    {
      text: "Remarks",
      Required: "Yes",
      IntName: "Remarks",
      Type: "Note",
      DisplayName: "Remarks",
      isToolTipContent: "",
      Options: "",
      ADAzureProperty: "",
      SPOProperty: "",
      id: "",
    },
    {
      text: "Attachment",
      Required: "Yes",
      IntName: "Attachment",
      Type: "File",
      DisplayName: "Attachment",
      isToolTipContent: "",
      Options: "",
      ADAzureProperty: "",
      SPOProperty: "",
      id: 4,
    },
  ]


export const BusinessUnits = [
    {label:"Bangalore", value:"Bangalore"}
]

export const ContractTypes = [
        { label: "MS Agreement For Nego2", value: "MSAgreementForNego2" },
        { label: "Advisory Agreement Contract", value: "AdvisoryAgreementContract" },
        { label: "Director Agreement -Olb", value: "DirectorAgreementOlb" },
        { label: "Employee Contract Agreement Negotiation3", value: "EmployeeContractAgreementNegotiation3" },
        { label: "Director Agreement Request", value: "DirectorAgreementRequest" },
        { label: "HR365 Contract nego 4", value: "HR365ContractNego4" },
        { label: "Employee Agreement", value: "EmployeeAgreement" },
        { label: "License Agreement contract", value: "LicenseAgreementContract" },
        { label: "Advisory Agreement- Obl", value: "AdvisoryAgreementObl" },
        { label: "Director Agreement Contract", value: "DirectorAgreementContract" },
        { label: "CNT EXP", value: "CNTEXP" }      
]

export const DraftType = [
    { label: "Third Party Draft", value: "Third Party Draft",ServerRelativeUrl:"" },
    { label: "Blank", value: "Blank",ServerRelativeUrl:"" }
]

export const RequestType = [

  { key: "Contract", text: "New Contract", label: "Contract Label", value: "Contract" },
  { key: "Amendment", text: "Amendment", label: "Amendment Label", value: "Amendment" },
  { key: "Renewal", text: "Renewal", label: "Renewal Label", value: "Renewal" }
]


export const isStringValidated = (value) => {
  if (value == null || value == undefined || value == "") {
    return false;
  } else {
    return true;
  }
};

export const isArrayValidated = (value) => {
  if (value == null || value == undefined || value.length === 0) {
    return false;
  } else {
    return true;
  }
};

export const SiteURL = localStorage.getItem("SiteURL");
export const accessToken = localStorage.getItem("CurrentToken");

export const currentUserID=JSON.parse(localStorage.getItem("CurrentUser")||"{}")?.currentUserId;
export const currentUser=JSON.parse(localStorage.getItem("CurrentUser")||"{}");
export const currentUserGuid=JSON.parse(localStorage.getItem("CurrentUser")||"{}")?.GUID

export const tenantURL=localStorage.getItem("TenantURL");

export async function getGroupIdByName(
  groupName: string,
): Promise<number | null> {
  try {
    const requestUrl = `${SiteURL}/_api/web/sitegroups?$filter=Title eq '${encodeURIComponent(
      groupName
    )}'&$top=1`;

    const response = await axios.get(requestUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json;odata=verbose",
      },
    });

    const results = response?.data?.d?.results;
    return results && results.length > 0 ? results[0].Id : null;
  } catch (error) {
    console.error("Error fetching group ID:", error);
    return null;
  }
}

export const updatedLicense = {
  P1A: "P1A",
  P2A: "P2A",
  P3A: "P3A",
  P4A: "P4A",
};


export const SelectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#F0F0F0",
    primary: "hsl(0,0%,80%)",
  },
});